import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { TextVariant } from './components/constants';
import { StyledErrorIcon } from './components/ErrorIcon.styled';
import { IconWithTooltip } from './components/IconWithTooltip';
import { getIconSize, getLoadingMediaErrorMsg, getTextVariant } from './components/utils';
import { StyledMediaContainerDiv } from './Preview.styled';

const StyledErrorWrapperDiv = styled('div')<{ variant: TextVariant }>`
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: ${({ variant }) => (variant === TextVariant.Horizontal ? 'row' : 'column')};
`;

type ErrorContainerProps = {
  height: number;
  width: number;
  position?: React.CSSProperties['position'];
};

export function ErrorContainer({ height, width, position = 'relative' }: ErrorContainerProps) {
  const { t } = useTranslation();

  const iconSize = getIconSize({ height, width });
  const textVariant = getTextVariant({ height, width });

  if (iconSize === 0) {
    return (
      <Tooltip title={getLoadingMediaErrorMsg(t)} placement="top-start">
        <StyledMediaContainerDiv data-test="creative-error" height={height} width={width} position={position} />
      </Tooltip>
    );
  }

  return (
    <StyledMediaContainerDiv data-test="creative-error" height={height} width={width} position={position}>
      <StyledErrorWrapperDiv variant={textVariant}>
        {textVariant === TextVariant.None ? (
          <IconWithTooltip iconSize={iconSize} />
        ) : (
          <>
            <StyledErrorIcon width={iconSize} height={iconSize} paddingVariant={textVariant} />
            <Typography component="p" variant="caption">
              {t('Failed to load media.')}&nbsp;
            </Typography>
            <Typography component="p" variant="caption">
              {t('If you are using Ad Block turn it off and try again.')}
            </Typography>
          </>
        )}
      </StyledErrorWrapperDiv>
    </StyledMediaContainerDiv>
  );
}
